<template>
  <div class="mobile_organization">
    <div class="title-bar flex-center-center">号商通商户注册</div>
    <div class="container">
      <div class="title-label">
        <div class="line"></div>
        商户信息
      </div>
      <div class="card">
        <div class="inputItem inputItem-col arrow">
          <div class="label_format"><label class="label_format_child">商户名称</label>
            <img class="img-size" src="../../assets/images/required.png" alt="">
          </div>
          <input v-model="personalForm.deptName" @input="personalForm.deptName = $event.target.value.replace(/\s/g, '')" type="text" placeholder="请输入商户名称（对外展示使用）">
        </div>
        <div class="backImg inputItem">
          <div class="rightClass flex-center-sb label_format">
            <label class="label_format_child">LOGO</label>
            <img class="img-size" src="../../assets/images/required.png" alt="">
          </div>
          <van-uploader v-model="fileList" :max-count="1" :after-read="(file)=>{return afterRead(file, type = 'img')}" @oversize="onOversize" :preview-options="{closeable:'true'}" @delete="onRemove">
            <div class="classData">
              <van-icon name="plus" size="16" />
              <span>上传</span>
            </div>
          </van-uploader>
        </div>
      </div>

      <div class="title-label">
        <div class="line"></div>
        联系人信息
      </div>
      <div class="card">
        <div class="inputItem inputItem-col">
          <div class="label_format"><label class="label_format_child">联系人姓名</label>
          <img class="img-size" src="../../assets/images/required.png" alt=""></div>
          <input type="text" v-model="personalForm.leader" placeholder="请输入姓名">
        </div>
          <div class="inputItem inputItem-col">
          <div class="label_format"><label class="label_format_child">联系电话</label>
          <img class="img-size" src="../../assets/images/required.png" alt=""></div>
          <input v-model="personalForm.phone" type="text" placeholder="请输入手机号">
        </div>
        <div class="inputItem">
          <input v-model="personalForm.dxyzm" type="text" placeholder="请输入短信验证码">
          <button v-show="countdown == 0" class="sendCode" @click="startCountdown">发送验证码</button>
          <button v-show="countdown > 0" class="sendCode">重新发送{{ countdown + '秒' }}</button>
        </div>
        <div class="inputItem inputItem-col">
          <div class="label_format"><label class="label_format_child">联系微信</label>
          <img class="img-size" src="../../assets/images/required.png" alt=""></div>
          <input type="text" v-model="personalForm.linkWx" placeholder="请输入绑定微信">
        </div>
        <div class="inputItem inputItem-col">
          <div class="label_format"><label class="label_format_child">联系地址</label>
          <img class="img-size" src="../../assets/images/required.png" alt=""></div>
          <input class="address" v-model="personalForm.contactAddress" type="text" disabled="true" placeholder="请授权联系地址">
          <button  class="getAdd" @click="getAddressIp1">获取位置</button>
        </div>
        <!-- <div class="inputItem inputItem-col">
          <div class="flx-bt">
            <div class="label_format"><label class="label_format_child">支付宝账户：</label></div>
            <div class="label_format color-orange">*与负责人姓名保持一致</div>
          </div>
          <input type="text" v-model="personalForm.alipayName" placeholder="请输入支付宝账户">
        </div> -->

      </div>
      <!-- 您的需求 -->
      <div class="title-label">
        <div class="line"></div>
        您的需求
      </div>
      <div class="card">
        <div class="inputItem">
          <textarea class="text-area" v-model="personalForm.remark" rows="5"  placeholder="请输入您的需求" />
        </div>
      </div>
      <div class="submit">
        <span>所有数据加密处理，确保安全无忧</span>
        <button class="nextBtn" @click="submitForm">提交</button>
      </div>
      <div class="footer-tip">
        承诺声明：所提交的信息，仅用于号商通的开户注册使用，我们承诺绝对保密，绝不外泄！
      </div>
    </div>

  </div>
</template>
<script>
import {
  Icon,
  Area,
  Popup,
  DatetimePicker,
  Uploader,
  Toast,
  Picker,
  ImagePreview,
} from "vant";
import api from "@/api";
import { listSearchMixin } from "@/config/mixin";
import { uploadFileToOSS } from '@/util/ossUpload'

export default {
  mixins: [listSearchMixin],
  name: "mPersonalBusiness",
  components: {
    [Icon.name]: Icon,
    [Area.name]: Area,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [Uploader.name]: Uploader,
    [Toast.name]: Toast,
    [Picker.name]: Picker,
  },
  data() {
    return {
      fileList: [],
      countdown: 0, //验证码 倒计时
      personalForm: {
        deptName: "", //团队名称
        img: "", //团队LOGO
        leader: "", //负责人姓名
        linkWx: "", //联系微信
        alipayName: "", //支付宝账户
        phone: "", //负责人手机号
        yzmRankey: "", //验证码key
        dxyzm: "", //验证码dxyzm
        contactAddress: "", //联系地址
        remark: "", //备注需求
      },
      fileTypes: ["png", "jpg", "jpeg", "jfif"]
    };
  },
  mounted() {
    // this.getAddressIp();
  },
  methods: {
    resetData() {
      this.personalForm = {
        deptName: "", //团队名称
        img: "", //团队LOGO
        leader: "", //负责人姓名
        linkWx: "", //联系微信
        alipayName: "", //支付宝账户
        phone: "", //负责人手机号
        yzmRankey: "", //验证码key
        dxyzm: "", //验证码dxyzm
        contactAddress: "", //联系地址
        remark: "",
      };
    },
    startCountdown() {
      if (!this.personalForm.phone) {
        Toast("请先填写联系手机号");
        return
      }
      let form = JSON.parse(JSON.stringify(this.personalForm))
      form.extra2 = form.phone
      let params = {
        url: api.sendCode,
        method: "POST",
        data: form,
      };
      this.sendReq(params, (res) => {
        if (res.code === 200) {
          this.personalForm.yzmRankey = res.data.uuid;
          this.countdown = 59;
          this.timer = setInterval(() => {
            if (this.countdown > 0) {
              this.countdown--;
            } else {
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        } else {
          Toast(res.msg);
        }
      });
    },
    getAddressIp1(){
      if ("geolocation" in navigator) {
				if (navigator.geolocation) {
					this.loadBMap().then(() => {
						this.getAddressIp();
				  });
					// 请求当前位置
					navigator.geolocation.getCurrentPosition(this.successFun, (error) => {
			    // 处理错误
			    switch(error.code) {
			    	case error.PERMISSION_DENIED:
			    		console.log("User denied the request for Geolocation.");
			    break;
			  	case error.POSITION_UNAVAILABLE:
			  		console.log("Location information is unavailable.");
			  		break;
			  	case error.TIMEOUT:
			  		console.log("The request to get user location timed out.");
			  		break;
			  	case error.UNKNOWN_ERROR:
						console.log("An unknown error occurred.");
						break;
						}
					});
				} else {
          alert('获取位置失败')
				}
			}
    },
    loadBMap() {
			return new Promise((resolve, reject) => {
				if (window.BMap) {
					resolve();
					return;
				}
				const script = document.createElement("script");
				script.src = `https://api.map.baidu.com/api?v=2.0&ak=你的AK&callback=onBMapLoadJS`;
				script.onerror = reject;
				window.onBMapLoadJS = () => {
					resolve();
				};
				document.head.appendChild(script);
			});
		},
    // 定位成功 → 解析出【街道】
    async successFun(position) {
      console.log('position: ', position);
      try {
        const lat = position.latitude ||  position.coords.latitude ;
        const lng = position.longitude || position.coords.longitude;
        const geoCoder = new T.Geocoder()
        const point = new T.LngLat(lng, lat);
        geoCoder.getLocation(point,(res) => {
          if( res.addressComponent) {
            const {address,province,city,county,town} = res.addressComponent
            this.personalForm.contactAddress = `${province}${city}${county}${town}${address}(${lng},${lat})`
          }else {
            const { city,district,province} = position.contactAddress
            this.personalForm.contactAddress = `${province}${city}${district}(${lng},${lat})`
          }
        })
      } catch (error) {
        const { city,district,province} = position.contactAddress
        this.personalForm.contactAddress = `${province}${city}${district}`
      }
    },
    getAddressIp() {
      const geolocation = new BMap.Geolocation();
			geolocation.getCurrentPosition(this.successFun, { provider: 'baidu' });
    },
    dateTime(value) {
      let date = value;
      let m = date.getMonth() + 1;
      let d = date.getDate();
      if (m >= 1 && m <= 9) {
        m = "0" + m;
      }
      if (d >= 0 && d <= 9) {
        d = "0" + d;
      }
      return date.getFullYear() + "年-" + m + "月-" + d + "日";
    },

    // 禁止弹出键盘
    noBomBox(Event) {
      document.activeElement.blur();
    },

    previewImgData(img) {
      var obj = [];
      if (img == 1) {
        obj.push("https://eyo88.oss-cn-hangzhou.aliyuncs.com/1689059593639");
      }
      if (img == 2) {
        obj.push("https://file.hswlkj.com/2017061690082046279");
      }
      ImagePreview({
        images: obj,
        closeable: true,
      });
    },
    afterRead(file, type) {
      file.status = "uploading";
      file.message = "上传中...";
      const fileType = file.file.type.split("/")[1]
      if (fileType && !this.fileTypes.includes(fileType)) {
        this.fileList = []
        Toast(`文件格式不正确, 请上传 ${this.fileTypes.join(' / ')} 图片格式文件!`);
        file.status = "done ";
        return
      }
      const isLt = file.file.size / 1024 / 1024 < 1
      if (!isLt) {
        this.fileList = []
        Toast(`上传图片大小不能超过 1 MB!`);
        file.status = "done ";
        return
      }
      // let t = setTimeout(() => {
      //   file.status = "failed";
      //   file.message = "请求超时";
      // }, 20000);

      let isLt2M = file.file.size / 1024 / 1024 // 判定图片大小
      const compress = isLt2M <= 0.2 ? 1
                    : isLt2M <= 2 ? 0.7
                    : isLt2M <= 4 ? 0.5
                    : isLt2M <= 6 ? 0.4
                    : 0.3
      let self = this
      let image = new Image()
      let resultBlob = ''
      image.src = URL.createObjectURL(file.file)
      image.onload = async () => {
        resultBlob = compress == 1 ? file.file : self.compressUpload(image, file.file, compress)
        self.aliyunHandle(file.file, resultBlob, file, type) // 阿里云 上传
      }

      // let formData = new FormData();
      // formData.append(
      //   "file",
      //   this.dataURLtoFileFun(file.content, file.file.name)
      // );
      // let params = {
      //   url: api.upload,
      //   method: "POST",
      //   contentType: "multipart/form-data",
      //   data: formData,
      // };
      // self.sendReq(
      //   params,
      //   (res) => {
      //     console.log("res: ", res);
      //     if (res.code == 200) {
      //       if (type === "img") {
      //         self.personalForm.img = res.url;
      //       }
      //       file.status = "done ";
      //       clearTimeout(t);
      //     } else {
      //       file.status = "failed";
      //       clearTimeout(t);
      //       Toast(res.msg);
      //     }
      //   },
      //   (err) => {
      //     file.status = "failed";
      //     file.message = "请求超时";
      //   }
      // );
      // file.status = 'uploading'
      // file.message = '上传中...'
    },
    // 阿里云 上传图片
    async aliyunHandle (file, resultBlob, item, type) {
      const res = await uploadFileToOSS(file, resultBlob)
      if (res.status === 200) {
        if (type === 'img') {
          this.personalForm.img = res.url
        }
        item.status = 'done '
      } else {
        item.status = 'failed'
        Toast('上传失败')
      }
    },
    /* 图片压缩方法-canvas压缩  根据画质压缩图片 */
    compressUpload(image, file, quality) {
      let canvas = document.createElement('canvas')
      let ctx = canvas.getContext('2d')
      let { width, height } = image
      canvas.width = width
      canvas.height = height
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(image, 0, 0, width, height)
      const type = file.type ? (file.type == 'image/png' ? 'image/jpeg' : file.type) : 'image/jpeg'
      let base64 = canvas.toDataURL(type, quality)
      // 压缩后调用方法进行base64转Blob
      const boldFile = this.base64ToBlob(base64, type)
      return boldFile
      canvas = null
    },
    // base64转Blob
    base64ToBlob(base64, contentType = '') {
      // 去除Base64字符串的前缀
      const cleanedBase64 = base64.split(',')[1] || base64
      // 对Base64字符串进行解码
      const byteCharacters = atob(cleanedBase64)
      // 将解码后的二进制字符串转换为Uint8Array
      const byteArrays = []
      for (let i = 0; i < byteCharacters.length; i++) {
        byteArrays.push(byteCharacters.charCodeAt(i))
      }
      const byteArray = new Uint8Array(byteArrays)

      // 创建Blob对象
      return new Blob([byteArray], { type: contentType })
    },
    dataURLtoFileFun(dataurl, filename) {
      // 将base64转换为文件，dataurl为base64字符串，filename为文件名（必须带后缀名，如.jpg,.png）
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {
        type: mime,
      });
    },
    onOversize(file) {
      console.log(file);
      Toast("文件大小不能超过 500kb");
    },
    onRemove() {
      this.fileList = []
      this.personalForm.img = ''
    },
    // 提交申请
    submitForm() {
      let self = this;
      console.log("self.personalForm: ", self.personalForm);
      if (self.personalForm.deptName === "") {
        Toast("请输入商户名称");
        return false;
      }
      if (self.personalForm.img === "") {
        Toast("请上传LOGO");
        return false;
      }
      if (self.personalForm.leader === "") {
        Toast("请输入联系人姓名");
        return false;
      }
      if (self.personalForm.linkWx === "") {
        Toast("请输入联系微信");
        return false;
      }
      // if (self.personalForm.alipayName === "") {
      //   Toast("请输入支付宝账户");
      //   return false;
      // }
      if (self.personalForm.phone === "") {
        Toast("请输入联系电话");
        return false;
      }
      if (self.personalForm.phone.length != 11) {
        Toast("手机号位数不对");
        return false;
      }
      if (self.personalForm.contactAddress === "") {
        Toast("请授权联系地址");
        return false;
      }
      let params = {
        url: api.submitDept,
        method: "POST",
        data: self.personalForm,
      };
      self.sendReq(params, (res) => {
        console.log("res: ", res);
        if (res.code === 200) {
          Toast.success("提交成功");
          self.resetData();
          self.countdown = 0;
          // self.$router.push({path: '/mStatus'})
        } else {
          Toast(res.msg);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.flex-center-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex-center-sb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mobile_organization {
  margin: auto;
  padding-bottom: 40px;
  width: 100%;
  max-width: 450px;
  height: 100vh;
  overflow-y: auto;
  background: #f3f7fa;
  font-family: PingFangSC, PingFang SC;

  .title-bar {
    height: 44px;
    font-weight: 600;
    font-size: 16px;
    color: #111111;
  }
  .container {
    padding: 0 10px;
    box-sizing: border-box;

    .title-label {
      margin-top: 20px;
      font-weight: 600;
      font-size: 14px;
      color: #111111;
      display: flex;
      align-items: center;

      .line {
        margin-left: 10px;
        margin-right: 8px;
        width: 4px;
        height: 20px;
        background: linear-gradient(90deg, #fe2f39 0%, #ff6634 100%);
        border-radius: 6px;
      }
    }

    .card {
      margin-top: 10px;
      padding: 15px;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 16px;

      .inputItem {
        position: relative;
        display: flex;
        align-items: center;
        .address {
          padding-right: 100px;
        }
        .text-area {
          resize: none;
          border: 1px solid rgba(0, 0, 0, .2);
          border-radius: 8px;
          width: 100%;
          padding: 10px;
        }
        .flx-bt {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .color-orange {
          color: #fa5e00 !important;
        }

        &:not(:last-child) {
          margin-bottom: 15px;
        }

        .label_format {
          font-weight: 600;
          font-size: 14px;
          color: #111111;
          flex-shrink: 0;
          position: relative;
          .img-size {
            position: absolute;
            left: -12px;
            top: 2px;
            width: 10px;
            height: 10px;
          }
        }
        .contactAddress {
          padding-right:100px;
        }
        .label_format_child {
          font-weight: 600;
          font-size: 14px;
          color: #111111;
          flex-shrink: 0;
        }

        input {
          padding-left: 10px;
          width: 100%;
          height: 44px;
          font-size: 14px;
          color: #111111;
          border: 1px solid rgba(0, 0, 0, 0.2);
          border-radius: 8px;
        }

        input::placeholder {
          position: relative;
          top: -1px;
          font-size: 14px;
          color: #aaaaaa;
        }

        .sendCode {
          position: absolute;
          right: 0;
          width: 100px;
          height: 44px;
          background: linear-gradient( 180deg, #444444 0%, #222222 100%);
          border-radius: 0px 8px 8px 0px;
          font-weight: bold;
          font-size: 14px;
          color: #FFD8A1;
        }
        .getAdd {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 100px;
          height: 44px;
          background: linear-gradient( 180deg, #444444 0%, #222222 100%);
          border-radius: 0px 8px 8px 0px;
          font-weight: bold;
          font-size: 14px;
          color: #FFD8A1;
        }
      }

      .inputItem-col {
        flex-direction: column;
        align-items: flex-start;

        .label_format {
          margin-bottom: 5px;
        }
      }

      .backImg {
        flex-direction: column;
        align-items: flex-start;

        .rightClass {
          margin-bottom: 5px;
          width: 100%;

          > span {
            font-size: 12px;
            color: #fe4400;
          }
        }

        .classData {
          width: 70px;
          height: 70px;
          font-size: 10px;
          color: #aaaaaa;
          border-radius: 8px;
          border: 1px solid rgba(0, 0, 0, 0.2);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          > span {
            margin-top: 2px;
          }
        }
      }
    }

    .submit {
      position: relative;
      margin-top: 20px;
      padding-top: 4px;
      box-sizing: border-box;
      height: 78px;
      background: #feece5;
      border-radius: 8px;
      text-align: center;

      > span {
        font-size: 12px;
        color: #fe4400;
      }

      .nextBtn {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 48px;
        font-weight: 600;
        font-size: 16px;
        color: #ffffff;
        background: linear-gradient(90deg, #fa5e00 0%, #ff8800 100%);
        border-radius: 8px;
      }
    }

    .footer-tip {
      margin-top: 20px;
      font-size: 12px;
      line-height: 16px;
      color: #aaaaaa;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/moblie/mOtherOrg.vue